import React, { useCallback } from 'react'
import { l } from '@manychat/manyui'

import { NODE_BADGE_ID } from 'common/builder/components/chart/FlowChart/constants'
import * as sharedStyles from 'common/builder/components/chart/FlowChart/nodes/shared/styles'
import { FlowChartContentRespontents } from 'common/builder/components/chart/FlowChart/types/FlowChartNode/FlowChartContentRespontents'
import { useFlowChartNodeContext } from 'common/builder/hooks/useFlowChartNodeContext'

import * as styles from './RespondentsBadge.styles'

interface RespondentsBadgeProps {
  respondents: FlowChartContentRespontents
}

export const RespondentsBadge = (props: RespondentsBadgeProps) => {
  const { onAnswersBtnClick } = useFlowChartNodeContext()

  const handleClick = useCallback(() => {
    if (!props.respondents.contentId || props.respondents.count === 0) {
      return
    }
    onAnswersBtnClick(props.respondents.contentId)
  }, [onAnswersBtnClick, props.respondents.contentId, props.respondents.count])

  return (
    <view onClick={handleClick} name={NODE_BADGE_ID} style={styles.Badge}>
      <richtext
        style={sharedStyles.chipText}
        text={l.translate('{n, plural, one {# Respondent} other {# Respondents}}', {
          n: props.respondents.count,
        })}
      />
    </view>
  )
}
